import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2" data-testid="footer-logo">
              <div className="w-10 h-10 bg-brand-orange rounded-full flex items-center justify-center">
                <span className="text-white font-heading font-bold text-lg">N</span>
              </div>
              <span className="font-heading font-bold text-xl text-white">
                Nexa<span className="text-brand-orange">Fusion</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Premium pet toys for happy, healthy pets. We believe every pet deserves fun, safe, and engaging toys.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="social-twitter">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/category/dog-chew-toys" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-dog-toys">
                  Dog Toys
                </Link>
              </li>
              <li>
                <Link to="/category/cat-toys" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-cat-toys">
                  Cat Toys
                </Link>
              </li>
              <li>
                <Link to="/category/puzzle-toys" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-best-sellers">
                  Best Sellers
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4">Policies</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-terms">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-refund">
                  Refund & Return Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-link-shipping">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-orange flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  8 E 23nd St #4692,<br />
                  New York, NY 10365,<br />
                  United States
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-brand-orange flex-shrink-0" />
                <a href="tel:+18887281766" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-phone">
                  +1-888-728-1766
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-brand-orange flex-shrink-0" />
                <a href="mailto:support@nexafusion.store" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-email">
                  support@nexafusion.store
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container-main py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © {currentYear} NexaFusion. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/200px-Visa_Inc._logo.svg.png"
              alt="Visa"
              className="h-6 opacity-60"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/200px-Mastercard-logo.svg.png"
              alt="Mastercard"
              className="h-8 opacity-60"
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/200px-PayPal.svg.png"
              alt="PayPal"
              className="h-5 opacity-60"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
